module.exports = __webpack_public_path__ + "img/firstEdition.12c40730.png";